// import required modules
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay, Pagination } from 'swiper/modules';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

import { useEffect, useState } from 'react';

import Image from 'components/global/Image';
import Typography from 'components/global/Typography';

import * as S from './styled/SmsAds.styled';

const SmsAds = ({ advertisements, language }) => {
	const [advertisementsData, setAdvertisementsData] = useState(advertisements);

	useEffect(() => {
		if (advertisements && advertisements.length) {
			setAdvertisementsData(
				advertisements.filter((item) => item.advLanguage === language || item.advLanguage === undefined)
			);
		}
	}, [advertisements, language]);

	return (
		<S.Container>
			<Swiper
				spaceBetween={30}
				centeredSlides={true}
				autoplay={{
					delay: 3000,
					disableOnInteraction: false
				}}
				pagination={{
					clickable: false
				}}
				modules={[Autoplay, Pagination]}
				className="AdsSwiper">
				{advertisementsData?.map((item, index) => (
					<SwiperSlide key={index}>
						<S.Image onClick={() => window.open(item.advLink, '_blank')}>
							<Image width="100%" height="100%" url={item.advImage} />
							<Typography fontWeight="500">{item.captionText}</Typography>
						</S.Image>
					</SwiperSlide>
				))}
			</Swiper>
		</S.Container>
	);
};

export default SmsAds;
